import { VIcon } from 'vuetify/lib/components/VIcon';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.hidden ? _c("div", [_vm.isMaintenanceMode && _vm.hasDeveloperToolsRole ? _c("div", {
    staticClass: "container-alert"
  }, [_c("div", {
    staticClass: "title-container"
  }, [_c(VIcon, {
    staticClass: "fa fa-info",
    attrs: {
      size: "1.3rem",
      color: "white"
    }
  }), _c("p", {
    staticClass: "title-container-text title-big"
  }, [_vm._v("Ongoing Maintenance")])], 1), _c("div", {
    staticClass: "scheduled-time"
  }, [_c("p", [_vm._v(" START: "), _c("span", {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.maintenanceStartTime)))])]), _c("p", [_vm._v(" END: "), _c("span", {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.maintenanceExpirationTime)))])])])]) : _vm._e(), _vm.upcomingMaintenance && !_vm.isMaintenanceMode ? _c("div", {
    staticClass: "container-alert upcoming"
  }, [_c("div", {
    staticClass: "title-container"
  }, [_c(VIcon, {
    staticClass: "fa fa-clock",
    attrs: {
      size: "1.3rem",
      color: "white"
    }
  }), _c("p", {
    staticClass: "title-container-text title-big"
  }, [_vm._v("Upcoming Maintenance")])], 1), _c("div", {
    staticClass: "messages"
  }, [_vm.upcomingMaintenance.description ? _c("p", [_vm._v(" " + _vm._s(_vm.customGroupDescription() || _vm.upcomingMaintenance.description) + " ")]) : _vm._e()]), _c("div", {
    staticClass: "scheduled-time"
  }, [_c("p", [_vm._v(" START: "), _c("span", {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.upcomingMaintenance.start_time)))]), !_vm.isTimeUnitilMaintenancePositive ? _c("span", {
    staticClass: "bold"
  }, [_vm._v(" ( in " + _vm._s(_vm.timeUntilMaintenance) + " ) ")]) : _vm._e()]), _c("p", [_vm._v(" END: "), _c("span", {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.upcomingMaintenance.end_time)) + " ( During " + _vm._s(_vm.timeUntilEnd) + " ) ")])])]), _vm.getTimeUntilMaintenanceNumber > 3 ? _c("div", {
    staticClass: "actions"
  }, [_c("button", {
    staticClass: "hide-button",
    on: {
      click: _vm.hideComponent
    }
  }, [_c(VIcon, {
    staticClass: "dark",
    attrs: {
      color: "white"
    }
  }, [_vm._v("mdi-close")])], 1)]) : _vm._e()]) : _vm._e(), _vm.isMaintenanceMode && _vm.canWorkDuringMaintenance ? _c("div", {
    staticClass: "container-alert allowed"
  }, [_c("div", {
    staticClass: "title-container"
  }, [_c(VIcon, {
    staticClass: "fa fa-check-circle",
    attrs: {
      size: "1.3rem",
      color: "white"
    }
  }), _c("p", {
    staticClass: "title-container-text title-big"
  }, [_vm._v("Ongoing Maintenance: You Can Work")])], 1), _c("div", {
    staticClass: "messages"
  }, [_c("p", [_vm._v(" " + _vm._s(_vm.customGroupDescription(true) || "You are allowed to work during this maintenance window. Some actions may be limited.") + " ")])]), _c("div", {
    staticClass: "scheduled-time"
  }, [_c("p", [_vm._v(" START: "), _c("span", {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.maintenanceStartTime)))])]), _c("p", [_vm._v(" END: "), _c("span", {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.maintenanceExpirationTime)))])])])]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };